import React from 'react';
import { withStyles, Grid, Typography, } from '@material-ui/core';
import PropTypes from 'prop-types';

const ICON1 = require('../../../images/icons/huangpai.png');
const ICON2 = require('../../../images/icons/hongpai.png');
const ICON3 = require('../../../images/icons/jiaoqiu.png');
const ICON4 = require('../../../images/icons/jinqiu.png');
const ICON5 = require('../../../images/icons/dianqiu.png');
const ICON6 = require('../../../images/icons/huanren.png');
const ICON7 = require('../../../images/icons/lianghuanyihong.png');
const ICON8 = require('../../../images/icons/dianqiuweijin.png');
const ICON9 = require('../../../images/icons/wulong.png');

class RaceEventHuanRen extends React.Component {

    getIcon(type) {
        switch (type) {
            case 1:
                return ICON4;
            case 2:
                return ICON3;
            case 3:
                return ICON1;
            case 4:
                return ICON2;
            case 8:
                return ICON5;
            case 9:
                return ICON6;
            case 15:
                return ICON7;
            case 16:
                return ICON8;
            case 17:
                return ICON9;
        }
    }

    render() {
        const { in_player_name, out_player_name, position, time, type } = this.props;
        return (
            <Grid container direction='row' alignItems='center' justifyContent='center' style={{ flex: 1 }}>
                <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ maxWidth: 'calc(50% - 16px)' }} >
                    {
                        position == 1 && <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ flex: 1 }} >
                            <Grid container direction='column' alignItems='flex-end' style={{ flex: 1 }}>
                                <Typography style={{ color: '#0D0D0D', fontSize: 12, maxWidth: 'calc(100% - 16px)' }}>{in_player_name}</Typography>
                                <Typography style={{ color: '#878787', fontSize: 12, maxWidth: 'calc(100% - 16px)' }}>{out_player_name}</Typography>
                            </Grid>
                            <img src={this.getIcon(type)} style={{ width: 10, height: 12.5, marginLeft: 4, marginRight: 4, objectFit: 'scale-down' }}></img>
                        </Grid>
                    }
                </Grid>
                <Grid container direction='column' alignItems='center' style={{ width: 25 }}>
                    <Grid style={{ backgroundColor: '#E2E2E2', width: 1, height: 10 }}></Grid>
                    <Grid container alignItems='center' justifyContent='center' style={{ backgroundColor: '#E2E2E2', width: 25, height: 25, borderRadius: 12.5 }}>
                        <Typography style={{ color: '#878787', fontSize: 12 }}>{time}</Typography>
                    </Grid>
                    <Grid style={{ backgroundColor: '#E2E2E2', width: 1, height: 10 }}></Grid>
                </Grid>
                <Grid container direction='row' alignItems='center' justifyContent='flex-start' style={{ maxWidth: 'calc(50% - 16px)', flex: 1 }}>
                    {
                        position == 2 && <Grid container direction='row' alignItems='center' justifyContent='flex-start' style={{ flex: 1 }}>
                            <img src={this.getIcon(type)} style={{ width: 10, height: 12.5, marginLeft: 4, marginRight: 4, objectFit: 'scale-down' }}></img>
                            <Grid container direction='column' style={{ flex: 1 }}>
                                <Typography style={{ color: '#0D0D0D', fontSize: 12, maxWidth: 'calc(100% - 16px)' }}>{in_player_name}</Typography>
                                <Typography style={{ color: '#878787', fontSize: 12, maxWidth: 'calc(100% - 16px)' }}>{out_player_name}</Typography>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid >
        );
    }
}

RaceEventHuanRen.propTypes = {
    time: PropTypes.number,
    in_player_name: PropTypes.string,
    out_player_name: PropTypes.string,
    position: PropTypes.number,
    type: PropTypes.number,
}

export default withStyles((theme) => ({
    circleBack: {
        border: 'solid 4px #FC2D33',
        borderRadius: 20,
        height: 40,
        width: 40,
    },
}))(RaceEventHuanRen);